<template>
  <div class="mail-service-list">
    <LbTable :data="data" :columns="columns" :row-id-fn="rowIdFn" />
  </div>
</template>

<script>
import columns from './columns';

import LbTable from '../../common/LbTable';

export default {
  name: 'MailServiceList',
  components: {
    LbTable,
  },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  computed: {
    columns() {
      return columns;
    },
  },
  methods: {
    rowIdFn(row) {
      return row.id;
    },
  },
};
</script>
<style lang="scss">
.mail-service-list {
  min-height: rem-calc(580px);
}
</style>
